export default {
  'loading.title': '리소스 로딩 중',
  'loading.subtitle': '잠시만 기다려 주세요...',
  'loading.initial.title': '리소스 로딩 중',
  'loading.initial.subtitle': '초기 로딩 시 시간이 걸릴 수 있습니다. 잠시만 기다려 주세요.',
};
